import type React from "react";

/**
 * Manual-entry-only number inputs (timesheet hour cells). A focused `type="number"` input steps its
 * value on the mouse wheel and on the arrow/page keys, so scrolling the page over an open cell can
 * silently change the hours that save on blur. These helpers cancel both; typing is unaffected.
 * The spinner arrows are hidden in each view's CSS.
 */

const blockWheel = (e: WheelEvent) => e.preventDefault();

/**
 * Ref callback for the input. React registers `onWheel` as a passive listener, where
 * preventDefault is ignored, so the wheel is cancelled through a native non-passive listener.
 * Module-level so the ref is stable and the listener is attached once per mounted input.
 */
export const blockNumberWheel = (el: HTMLInputElement | null) => {
  if (!el) return;
  el.addEventListener("wheel", blockWheel, { passive: false });
  return () => el.removeEventListener("wheel", blockWheel);
};

const STEP_KEYS = new Set(["ArrowUp", "ArrowDown", "PageUp", "PageDown"]);

/** Cancel the keys that step a number input. Call first in the input's onKeyDown. */
export function preventNumberStepKeys(e: React.KeyboardEvent): void {
  if (STEP_KEYS.has(e.key)) e.preventDefault();
}
